<template>
  <div :class="classModifiers">
    <div class="notification-item-trade-confirmed__content">
      <div class="notification-item-trade-confirmed__container">
        <div class="notification-item-trade-confirmed__icon">
          <img v-if="isProcessedOrMatched" src="@/assets/icons/success-icon-small.svg" />
          <img v-else src="@/assets/icons/pending-large.svg" />
        </div>
        <h4 class="notification-item-trade-confirmed__title">{{ offerStatusLongText }}</h4>
        <div
          v-if="showAutoCloseLoader"
          class="notification-item-trade-confirmed__loader"
          :style="{ '--close-timeout': `${closeTimeout}ms` }"
        >
          <svg width="32" height="32" viewBox="0 0 32 32">
            <circle cx="16" cy="16" r="13" class="notification-item-trade-confirmed__loader-ring" />
          </svg>
        </div>
        <button
          @click="onClose"
          v-show="closeButton"
          class="notification-item-trade-confirmed__close"
        ></button>
      </div>
      <div
        class="notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"
      >
        <div class="notification-item-trade-confirmed__market">
          {{ marketName }}
        </div>
      </div>
      <div v-if="showHistory">
        <div
          class="row notification-item-trade-confirmed__container notification-item-trade-confirmed__container--simple"
          v-for="stock in history"
        >
          <div class="notification-item-trade-confirmed__info">
            <div>
              {{ soldOrBoughtText(stock.TradeType) }}
              <span>{{ stock.Quantity }} {{ yesNoText(stock.TradeType) }}</span>
              <span v-if="!isMarketSingle" class="notification-item-trade-confirmed__contract">
                in <span v-contract-name>{{ contractName }}</span>
              </span>
              <span class="notification-item-trade-confirmed__min-price">
                at <span v-price-display.cents="stock.PricePerShare"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div
        class="notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"
        v-if="showCashFooter"
      >
        <div class="row">
          <div class="column small-6 text-left">
            <div v-if="showProfitLoss">
              {{ profitOrLossText }}: <span v-price-display.fixed3="profit"></span>
            </div>
          </div>
          <div class="column small-6 text-right">
            <div v-if="showFees">Fees: <span v-price-display.fixed3="fee"></span></div>
          </div>
        </div>
        <div class="row">
          <template v-if="offerId && dateCreated">
            <div class="column small-12">
              <div>Date: {{ dateCreated }}</div>
            </div>
          </template>
          <template v-if="offerId">
            <div class="column small-6 text-left">
              <div>Confirmation: {{ base32(offerId) }}</div>
            </div>
            <div class="column small-6 text-right">
              <div>&nbsp;</div>
            </div>
          </template>
          <div class="column small-6 text-left">
            <div v-if="showRisk">Risk Adj.: <span v-price-display.fixed3="risk"></span></div>
          </div>
          <div class="column small-6 text-right">
            <div>
              <strong
                ><plus-minus-sign></plus-minus-sign> Cash:
                <span v-price-display.fixed3="cost"></span
              ></strong>
            </div>
          </div>
        </div>
      </div>
      <div
        class="notification-item-trade-confirmed__container notification-item-trade-confirmed__container--footer"
        v-else-if="showOpenOfferRecordedFooter && offerId"
      >
        <div class="row">
          <template v-if="dateCreated">
            <div class="column small-12">
              <div>Date: {{ dateCreated }}</div>
            </div>
          </template>
          <div class="column small-6 text-left">
            <div>Confirmation: {{ base32(offerId) }}</div>
          </div>
          <div class="column small-6 text-right">
            <div>&nbsp;</div>
          </div>
        </div>
      </div>
      <div :class="bottomContainerClassModifiers" v-if="remainingQuantity > 0">
        <div class="notification-item-trade-confirmed__icon" v-if="false">
          <img src="@/assets/icons/pending-large.svg" />
        </div>
        <div class="notification-item-trade-confirmed__info">
          <div>
            {{ soldOrBoughtTextOffer() }}
            <span>{{ remainingQuantity }} {{ yesNoText(offerType) }}</span>
            <span v-if="!isMarketSingle" class="notification-item-trade-confirmed__contract">
              in <span v-contract-name>{{ contractName }}</span>
            </span>
            <span class="notification-item-trade-confirmed__min-price">
              at <span v-price-display.cents="minPrice"></span>
            </span>
          </div>
        </div>
      </div>
      <div class="notification-item-trade-confirmed__footer" v-if="showFooter">
        <div class="row">
          <div class="column small-6">
            <div
              v-if="showToggle"
              class="notification-item-trade-confirmed__toggle"
              @click="onToggle"
            >
              <template v-if="advanced">Hide</template>
              <template v-else>Details</template>
            </div>
            <div v-else>&nbsp;</div>
          </div>
          <div class="column small-6 text-right notification-item-trade-confirmed__share">
            <div class="notification-item-trade-confirmed__share-buttons">
              <a
                @click.prevent="onTwitterShare"
                class="notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--x"
              >
              </a>
              <a
                @click.prevent="onFacebookShare"
                class="notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--facebook"
              >
              </a>
              <a
                v-if="!isWrapperApp"
                :href="mailto"
                @click="onEmailShare"
                class="notification-item-trade-confirmed__share-link notification-item-trade-confirmed__share-link--email"
              >
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./notification-item-trade-confirmed.js"></script>
<style src="./notification-item-trade-confirmed.scss" lang="scss"></style>
